import react from "react";
import "./styles.css";
import team from "../../../img/banner-horizontal.jpg";
import team2 from "../../../img/about/banner-nosotros2.png";
import team3 from "../../../img/about/banner-nosotros3.png";
import teamMob from "../../../img/about/banner-nosotros-mobile.png";
import teamMob2 from "../../../img/about/banner-nosotros-mobile2.png";
import teamMob3 from "../../../img/about/banner-nosotros-mobile3.png";

export const SliderAbout = () => {
  return (
    <div>
      <div
        id="carouselExampleIndicators"
        className="carousel slide"
        data-bs-ride="true"
      >
        <div className="carousel-indicators">
          <button
            type="button"
            data-bs-target="#carouselExampleIndicators"
            data-bs-slide-to="0"
            className="active"
            aria-current="true"
            aria-label="Slide 1"
          ></button>
          <button
            type="button"
            data-bs-target="#carouselExampleIndicators"
            data-bs-slide-to="1"
            aria-label="Slide 2"
          ></button>
          <button
            type="button"
            data-bs-target="#carouselExampleIndicators"
            data-bs-slide-to="2"
            aria-label="Slide 3"
          ></button>
        </div>
        <div className="carousel-inner">
          <div className="carousel-item active">
            <img src={team} className="d-block w-100 web-about" alt="..." />
            <img src={teamMob} className="d-block w-100 mob-about" alt="..." />
          </div>
          <div className="carousel-item">
            <img src={team2} className="d-block w-100 web-about" alt="..." />
            <img src={teamMob2} className="d-block w-100 mob-about" alt="..." />
          </div>
          <div className="carousel-item">
            <img src={team3} className="d-block w-100 web-about" alt="..." />
            <img src={teamMob3} className="d-block w-100 mob-about" alt="..." />
          </div>
        </div>
        <button
          className="carousel-control-prev"
          type="button"
          data-bs-target="#carouselExampleIndicators"
          data-bs-slide="prev"
        >
          <span
            className="carousel-control-prev-icon"
            aria-hidden="true"
          ></span>
          <span className="visually-hidden">Previous</span>
        </button>
        <button
          className="carousel-control-next"
          type="button"
          data-bs-target="#carouselExampleIndicators"
          data-bs-slide="next"
        >
          <span
            className="carousel-control-next-icon"
            aria-hidden="true"
          ></span>
          <span className="visually-hidden">Next</span>
        </button>
      </div>
    </div>
  );
};
